module.exports = __webpack_public_path__ + "web/img/icon-07.b04cbc55.png";